import type { RoleDetail } from '@skewb-works/contracts';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useRole, useSubjects } from './useAccessControlApi';

export interface RoleData {
  roleId: number | undefined;
  isEdit: boolean;
  role: RoleDetail | undefined;
  subjects: string[];
  /** True until the subject list has loaded; gates mounting the matrix against an empty list. */
  subjectsLoading: boolean;
}

/** Reads the route id and loads the role (when editing) plus the subject list. */
export function useRoleData(): RoleData {
  const params = useParams<{ roleId?: string }>();
  const roleId = params.roleId ? Number(params.roleId) : undefined;

  const { data: role } = useRole(roleId);
  const { data: subjectsData, isPending: subjectsLoading } = useSubjects();
  const subjects = useMemo<string[]>(() => subjectsData?.subjects ?? [], [subjectsData]);

  return { roleId, isEdit: roleId !== undefined, role, subjects, subjectsLoading };
}
